import { useRef, useState } from 'react';
import classes from './LoginPage.module.scss';

import { post, endLoading, alrt, alrtConfirm } from '../../lib/legacy';
import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

import { Grid } from '@mui/material';

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import MainBtn from '../MainBtn/MainBtn';
import CustomInput from '../CustomInput/CustomInput';
import CustomPhoneInput from '../CustomPhoneInput/CustomPhoneInput';
import TextBtn from '../TextBtn/TextBtn';
import CleaveInput from '../CleaveInput/CleaveInput';
import CardTab from '../CardTab/CardTab';

import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const LoginPage = (props) => {
	const emailRegex =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	const btnRef = useRef(null);

	const [phone, setPhone] = useState(null);
	const [email, setEmail] = useState(null);
	const [taj, setTaj] = useState(null);

	const [smsCode, setSmsCode] = useState(null);
	const [emailCode, setEmailCode] = useState(null);

	const [emailCounter, setEmailCounter] = useState(60);
	const [smsCounter, setSMSCounter] = useState(60);

	const [activeCard, setActiveCard] = useState(0);

	const [mode, setMode] = useState('EMAIL');

	const [showPassword, setShowPassword] = useState(false);

	const [checkedPw, setCheckedPw] = useState('');

	const [password, setPassword] = useState('');
	const [passwordConfirm, setPasswordConfirm] = useState('');

	//const [correctPW, setCorrectPW] = useState(false);

	const [forgotPassword, setForgotPassword] = useState(false);

	const [pwChecks, setPwChecks] = useState({
		eightChar: false,
		lowerCase: false,
		upperCase: false,
		number: false,
	});

	let emailInterval;
	let smsInterval;
	let _emailCounter = 60;
	let _smsCounter = 60;

	// useEffect(() => {
	// 	const listener = (event) => {
	// 		if (event.code === 'Enter' || event.code === 'NumpadEnter') {
	// 			console.log('Enter key was pressed. Run your function.');
	// 			event.preventDefault();
	// 			btnRef.current.click();
	// 		}
	// 	};
	// 	document.addEventListener('keydown', listener);
	// 	return () => {
	// 		document.removeEventListener('keydown', listener);
	// 	};
	// }, []);

	// Login steps
	const loginStep1 = () => {
		if (mode === 'EMAIL') {
			const trimmedEmail = email.trim();
			if (!trimmedEmail || !phone) {
				alrt(props.translates ? props.translates.missing_email : "Hiányzó email cím vagy telefonszám!");
			}
			if (!emailRegex.test(trimmedEmail)) {
				alrt(props.translates ? props.translates.wrong_email : "Hibás email cím!");
				return;
			}
		}
		if (mode === 'TAJ') {
			if (!taj || !phone) {
				alrt(props.translates ? props.translates.missing_taj_or_phone.replace('{{governmentIdType}}', props.governmentIdType) : "Hiányzó TAJ szám vagy telefonszám!");
			}
		}

		if (!isValidPhoneNumber(phone)) {
			alrt(props.translates ? props.translates.wrong_phone : "Hibás telefonszám!");
			return;
		}

		const _phone = parsePhoneNumber(phone);

		post(
			'api/v1/patient-portal/login',
			{
				alias: props.alias,
				email: email,
				phone: `+${_phone.countryCallingCode}${_phone.nationalNumber}`,
				taj: taj,
				method: mode,
				forgottPassword: forgotPassword,
			},
			true
		)
			.then((response) => response.json())
			.then((response) => {
				endLoading();
				switch (response.responseCode) {
					case 'OK':
						if (mode === 'EMAIL') {
							setActiveCard(1);
							setEmailInterval();
						}
						if (mode === 'TAJ') {
							setActiveCard(2);
							setSMSInterval();
						}
						break;
					case 'NEED_PASSWORD':
						setActiveCard(4);
						break;
					case 'NO_METHOD_OR_ALIAS':
					case 'NO_EMAIL_OR_PHONE':
					case 'NO_TAJ_OR_PHONE':
					case 'NO_BILLING_DATA':
						alrt(props.translates ? props.translates.wrong_data : "Hibás adatmegadás!");
						break;
					case 'NO_PATIENTS':
						alrt(props.translates ? props.translates.no_patient : "A megadott adatokkal nem található páciens!");
						break;
					case 'NO_ACCESS':
						alrt(props.translates ? props.translates.no_access : "A megadott adatokkal nincs hozzáférése a portálhoz!");
						break;
					default:
						alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
						break;
				}
			})
			.catch((err) => {
				endLoading();
				alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
				console.log(err);
			});
	};

	const loginStep2 = () => {
		const _phone = parsePhoneNumber(phone);

		post(
			'api/v1/patient-portal/check-email-token',
			{
				alias: props.alias,
				email: email,
				phone: `+${_phone.countryCallingCode}${_phone.nationalNumber}`,
				taj: taj,
				method: mode,
				emailToken: emailCode,
			},
			true
		)
			.then((response) => response.json())
			.then((response) => {
				endLoading();
				switch (response.responseCode) {
					case 'OK':
						setActiveCard(2);
						setSMSInterval();
						break;
					case 'NOT_VERIFIED':
						alrt(props.translates ? props.translates.not_verified : "A megadott kód nem érvényes!");
						break;
					default:
						alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
						break;
				}
			})
			.catch((err) => {
				endLoading();
				alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
				console.log(err);
			});
	};

	const loginStep3 = () => {
		if (!smsCode) {
			return;
		}

		const _phone = parsePhoneNumber(phone);

		post(
			'api/v1/patient-portal/check-sms-code',
			{
				alias: props.alias,
				email: email,
				phone: `+${_phone.countryCallingCode}${_phone.nationalNumber}`,
				taj: taj,
				method: mode,
				emailToken: emailCode,
				code: smsCode,
				password: password,
			},
			true
		)
			.then((response) => response.json())
			.then((response) => {
				endLoading();
				switch (response.responseCode) {
					case 'OK':
						let hash = response.hash;
						setActiveCard(0);
						if (props.onLogin) {
							props.onLogin(hash);
						}
						// console.log(hash);
						break;
					default:
						alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
						break;
				}
			})
			.catch((err) => {
				endLoading();
				alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
				console.log(err);
			});
	};

	const passwordSend = () => {
		if (!checkedPw) {
			return;
		}

		const _phone = parsePhoneNumber(phone);

		post(
			'api/v1/patient-portal/check-password',
			{
				alias: props.alias,
				email: email,
				phone: `+${_phone.countryCallingCode}${_phone.nationalNumber}`,
				taj: taj,
				method: mode,
				// emailToken: emailCode,
				// code: smsCode,
				password: checkedPw,
			},
			true
		)
			.then((response) => response.json())
			.then((response) => {
				endLoading();
				switch (response.responseCode) {
					case 'OK':
						let hash = response.hash;
						setActiveCard(0);
						if (props.onLogin) {
							props.onLogin(hash);
						}
						break;
					case 'NOT_VERIFIED':
						alrt(props.translates ? props.translates.incorrect_password : "A megadott jelszó hibás!");
						break;
					default:
						alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
						break;
				}
			})
			.catch((err) => {
				endLoading();
				alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
				console.log(err);
			});
	};

	const resendEmail = () => {
		loginStep1();
		_emailCounter = 60;
		setEmailCounter(60);
	};

	const resendSMS = () => {
		loginStep2();
		_smsCounter = 60;
		setSMSCounter(60);
	};

	// Resend email / sms
	const setEmailInterval = () => {
		emailInterval = setInterval(() => {
			if (_emailCounter > 0) {
				_emailCounter -= 1;
				setEmailCounter((prev) => prev - 1);
			} else {
				clearInterval(emailInterval);
			}
		}, 1000);
	};

	const setSMSInterval = () => {
		smsInterval = setInterval(() => {
			if (_smsCounter > 0) {
				_smsCounter -= 1;
				setSMSCounter((prev) => prev - 1);
			} else {
				clearInterval(smsInterval);
			}
		}, 1000);
	};

	const checkPassword = (pw, type) => {
		if (type === 'first') {
			if (!pw) {
				setPwChecks({ eightChar: false, lowerCase: false, upperCase: false, number: false, match: false });
				return;
			}

			let lowerCaseRegex = /[a-z]/;
			let upperCaseRegex = /[A-Z]/;
			let numberRegex = /[0-9]/;

			let _checks = { ...pwChecks };

			if (pw.length >= 8) {
				_checks.eightChar = true;
			} else {
				_checks.eightChar = false;
			}

			if (lowerCaseRegex.test(pw)) {
				_checks.lowerCase = true;
			} else {
				_checks.lowerCase = false;
			}

			if (upperCaseRegex.test(pw)) {
				_checks.upperCase = true;
			} else {
				_checks.upperCase = false;
			}

			if (numberRegex.test(pw)) {
				_checks.number = true;
			} else {
				_checks.number = false;
			}
			setPwChecks(_checks);
		}
	};

	const isPasswordValid = ((password === passwordConfirm) && (password !== '' && passwordConfirm !== ''))

	const checkSMSCode = () => {
		const _phone = parsePhoneNumber(phone);

		post(
			'api/v1/patient-portal/check-sms-code-valid',
			{
				alias: props.alias,
				email: email,
				phone: `+${_phone.countryCallingCode}${_phone.nationalNumber}`,
				taj: taj,
				method: mode,
				code: smsCode,
			},
			true
		)
			.then((response) => response.json())
			.then((response) => {
				endLoading();
				switch (response.responseCode) {
					case 'OK':
						setActiveCard(3);
						break;
					case 'NOT_VERIFIED':
						alrt(props.translates ? props.translates.not_verified : "A megadott kód nem érvényes!");
						break;
					default:
						alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
						break;
				}
			})
			.catch((err) => {
				endLoading();
				alrt(props.translates ? props.translates.server_error : "Szerver hiba! Kérjük próbálja meg később!");
				console.log(err);
			});
	};

	return (
		<div className={classes.main}>
			{activeCard === 0 ? (
				<div>
					<Grid container>
						<Grid item xs={12}>
							<div style={{ display: 'flex', marginBottom: '2rem' }}>
								<CardTab
									title={props.translates ? props.translates.with_email : "Email címmel"}
									selected={mode === 'EMAIL'}
									onClick={() => setMode('EMAIL')}
								/>
								<CardTab
									title={props.governmentIdType}
									selected={mode === 'TAJ'}
									onClick={() => setMode('TAJ')}
								/>
							</div>
							{mode === 'EMAIL' && (
								<CustomInput
									className={classes.input}
									label={props.translates ? props.translates.email_address : "Email cím"}
									onChange={(value) => setEmail(value)}
									defaultValue={email}
								/>
							)}
							{mode === 'TAJ' && (
								<CleaveInput
									className={classes.input}
									label={props.governmentIdType}
									options={props.countryCode === 'HU' ? { delimiter: '-', blocks: [3, 3, 3], numeral: false } : { delimiter: '', blocks: [20], numericOnly: false }}
									inputStyle={{ marginBottom: 0 }}
									onChange={(value) => {
										setTaj(value);
									}}
									defaultValue={taj}
								/>
							)}
							<CustomPhoneInput
								className={classes.input}
								label={props.translates ? props.translates.phone_number : "Telefonszám"}
								value={phone}
								onChange={(phone) => {
									if (phone) {
										setPhone(phone);
									} else {
										setPhone(null);
									}
								}}
							/>
						</Grid>
					</Grid>
					<Grid container justifyContent={'center'}>
						<Grid item>
							<MainBtn
								onClick={() => {
									loginStep1();
								}}
								disabled={!phone || (mode === 'EMAIL' && !email) || (mode === 'TAJ' && !taj)}
								ref={btnRef}
							>
								{props.translates ? props.translates.next : "Tovább"}
							</MainBtn>
						</Grid>
					</Grid>
				</div>
			) : null}
			{activeCard === 1 ? (
				<div>
					<Grid container alignItems={'center'} style={{ marginBottom: '2rem' }}>
						<Grid item sm={2} xs={12}>
							<TextBtn
								text={props.translates ? props.translates.back : "Vissza"}
								leftIcon={KeyboardBackspaceIcon}
								onClick={() => {
									setActiveCard(0);
								}}
							/>
						</Grid>
						<Grid item sm={8} xs={12}></Grid>
						<Grid item sm={2} xs={12}></Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12}>
							<p className={classes.paragraph} style={{ marginBottom: '2rem', color: 'black' }}>
								{props.translates ? props.translates.email_code_text : "Kérjük adja meg az e-mailben küldött azonosító kódot:"}
							</p>
							<CustomInput
								label={props.translates ? props.translates.email_code : "Email kód"}
								type="number"
								onChange={(value) => setEmailCode(value)}
							/>
							<Grid container justifyContent={'center'}>
								<Grid item>
									<TextBtn
										style={{ justifyContent: 'center' }}
										text={`${props.translates ? props.translates.resend_email : "Email újraküldése"} ${emailCounter > 0 ? `(${emailCounter})` : ''}`}
										disabled={emailCounter}
										onClick={() => resendEmail()}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid container justifyContent={'center'} style={{ marginTop: '2rem' }}>
						<Grid item>
							<MainBtn
								disabled={!emailCode}
								onClick={() => {
									loginStep2();
								}}
							>
								{props.translates ? props.translates.next : "Tovább"}
							</MainBtn>
						</Grid>
					</Grid>
				</div>
			) : null}
			{activeCard === 2 ? (
				<div>
					<Grid container alignItems={'center'} style={{ marginBottom: '2rem' }}>
						<Grid item sm={2} xs={12}>
							<TextBtn
								text={props.translates ? props.translates.back : "Vissza"}
								leftIcon={KeyboardBackspaceIcon}
								onClick={() => {
									if (mode === 'EMAIL') {
										setActiveCard(1);
									}
									if (mode === 'TAJ') {
										setActiveCard(0);
									}
								}}
							/>
						</Grid>
						<Grid item sm={8} xs={12}></Grid>
						<Grid item sm={2} xs={12}></Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12}>
							<p className={classes.paragraph} style={{ marginBottom: '2rem', color: 'black' }}>
								{props.translates ? props.translates.sms_code_text : "Kérjük adja meg az SMS-ben küldött azonosító kódot:"}
							</p>

							<CustomInput label={props.translates ? props.translates.sms_code : "SMS kód"} type="number" onChange={(value) => setSmsCode(value)} />
							<Grid container justifyContent={'center'}>
								<Grid item>
									<TextBtn
										style={{ justifyContent: 'center' }}
										text={`${props.translates ? props.translates.resend_sms : "SMS újraküldése"} ${smsCounter > 0 ? `(${smsCounter})` : ''}`}
										disabled={smsCounter}
										onClick={() => resendSMS()}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid container justifyContent={'center'} style={{ marginTop: '2rem' }}>
						<Grid item>
							<MainBtn
								disabled={!smsCode}
								onClick={() => {
									checkSMSCode();
								}}
							>
								{props.translates ? props.translates.next : "Tovább"}
							</MainBtn>
						</Grid>
					</Grid>
				</div>
			) : null}
			{activeCard === 3 ? (
				<div>
					<Grid container alignItems={'center'} style={{ marginBottom: '2rem' }}>
						<Grid item sm={2} xs={12}>
							<TextBtn
								text={props.translates ? props.translates.back : "Vissza"}
								leftIcon={KeyboardBackspaceIcon}
								onClick={() => {
									setActiveCard(2);
								}}
							/>
						</Grid>
						<Grid item sm={8} xs={12}>
							<p className={classes.subTitle}>{props.translates ? props.translates.create_a_password : "Jelszó létrehozása"}</p>
						</Grid>
						<Grid item sm={2} xs={12}></Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12}>
							<p className={classes.paragraph} style={{marginBottom: '2rem', color: 'black'}}>
								{props.translates ? props.translates.add_password_text : "Kérjük, adja meg állandó jelszavát!"}
							</p>

							<div style={{display: 'flex', alignItems: 'center'}}>
								<CustomInput
									style={{marginBottom: '1rem', flex: 1}}
									label={props.translates ? props.translates.new_password : "Új jelszó"}
									type={showPassword ? 'text' : 'password'}
									onChange={(value) => {
										setPassword(value)
										checkPassword(value, 'first');
									}}
								/>
								<div className={classes.eyeIcon} onClick={() => setShowPassword((prev) => !prev)}>
									<FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash}/>
								</div>
							</div>
							<div style={{display: 'flex', alignItems: 'center'}}>
								<CustomInput
									style={{marginBottom: '1rem', flex: 1}}
									label={props.translates ? props.translates.new_password_again : "Új jelszó mégegyszer"}
									type={showPassword ? 'text' : 'password'}
									onChange={(value) => {
										setPasswordConfirm(value)
										checkPassword(value, 'second');
									}}
								/>
								<div className={classes.eyeIcon} onClick={() => setShowPassword((prev) => !prev)}>
									<FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash}/>
								</div>
							</div>
							<div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
								<p
									style={{ color: 'black', fontSize: '14px' }}
								>
									{props.translates ? props.translates.password_requirements : "A jelszó követelménye"}
								</p>
								<div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '4px',
											color: pwChecks.eightChar ? '#7fde94' : '#ed535c'
										}}
										className={classes.pwText}
									>
										{pwChecks.eightChar
											?
											<CheckIcon sx={{width: '16px', height: '16px'}}/>
											:
											<CloseIcon sx={{width: '16px', height: '16px'}}/>
										}
										<p className={classes.paragraph} style={{margin: 0}}>
											{props.translates ? props.translates.min_8_char : "min 8 karakter"}
										</p>
									</div>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '4px',
											color: pwChecks.lowerCase ? '#7fde94' : '#ed535c'
										}}
										className={classes.pwText}
									>
										{pwChecks.lowerCase
											?
											<CheckIcon sx={{width: '16px', height: '16px'}}/>
											:
											<CloseIcon sx={{width: '16px', height: '16px'}}/>
										}
										<p style={{margin: 0}}>
											{props.translates ? props.translates.lower_case : "kisbetű"}
										</p>
									</div>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '4px',
											color: pwChecks.upperCase ? '#7fde94' : '#ed535c'
										}}
										className={classes.pwText}
									>
										{pwChecks.upperCase
											?
											<CheckIcon sx={{width: '16px', height: '16px'}}/>
											:
											<CloseIcon sx={{width: '16px', height: '16px'}}/>
										}
										<p className={classes.paragraph} style={{margin: 0}}>
											{props.translates ? props.translates.upper_case : "nagybetű"}
										</p>
									</div>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '4px',
											color: pwChecks.number ? '#7fde94' : '#ed535c'
										}}
										className={classes.pwText}
									>
										{pwChecks.number
											?
											<CheckIcon sx={{width: '16px', height: '16px'}}/>
											:
											<CloseIcon sx={{width: '16px', height: '16px'}}/>
										}
										<p className={classes.paragraph} style={{margin: 0}}>
											{props.translates ? props.translates.number : "szám"}
										</p>
									</div>
									<span
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '4px',
											color: isPasswordValid ? '#7fde94' : '#ed535c'
										}}
										className={classes.pwText}
									>
											{isPasswordValid
												?
												<CheckIcon sx={{width: '16px', height: '16px'}}/>
												:
												<CloseIcon sx={{width: '16px', height: '16px'}}/>
											}
										<p className={classes.paragraph} style={{margin: 0}}>
												{props.translates ? props.translates.password_match : 'Jelszavak megegyeznek'}
										</p>
										</span>
								</div>
							</div>
						</Grid>
					</Grid>
					<Grid container justifyContent={'center'} style={{marginTop: '2rem'}}>
						<Grid item>
							<MainBtn
								disabled={!isPasswordValid || !pwChecks.lowerCase || !pwChecks.upperCase || !pwChecks.number || !pwChecks.eightChar}
								onClick={() => {
									loginStep3();
								}}
							>
								{props.translates ? props.translates.next : "Tovább"}
							</MainBtn>
						</Grid>
					</Grid>
				</div>
			) : null}
			{activeCard === 4 ? (
				<div>
					<Grid container alignItems={'center'} style={{marginBottom: '2rem'}}>
						<Grid item sm={2} xs={12}>
							<TextBtn
								text={props.translates ? props.translates.back : "Vissza"}
								leftIcon={KeyboardBackspaceIcon}
								onClick={() => {
									setActiveCard(0);
								}}
							/>
						</Grid>
						<Grid item sm={8} xs={12}>
							<p
								className={classes.subTitle}>{props.translates ? props.translates.password_check : "Jelszó ellenőrzés"}</p>
						</Grid>
						<Grid item sm={2} xs={12}></Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12}>
							<p className={classes.paragraph} style={{marginBottom: '2rem'}}>
								{props.translates ? props.translates.password_check_text : "Kérjük, a folytatáshoz adja meg a korábban rögzített jelszavát! "}
							</p>

							<div style={{display: 'flex', alignItems: 'center'}}>
								<CustomInput
									style={{marginBottom: '1rem', flex: 1}}
									label={props.translates ? props.translates.password : "Jelszó"}
									type={showPassword ? 'text' : 'password'}
									onChange={(value) => {
										setCheckedPw(value);
									}}
								/>
								<div className={classes.eyeIcon} onClick={() => setShowPassword((prev) => !prev)}>
									<FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash}/>
								</div>
							</div>
							<Grid container justifyContent={'center'}>
								<Grid item>
									<TextBtn
										style={{justifyContent: 'center'}}
										text={props.translates ? props.translates.forgot_password : "Elfelejtettem a jelszavam"}
										disabled={false}
										onClick={() => {
											alrtConfirm(
												props.translates ? props.translates.create_new_pw_text : "Új jelszó megadásához szüksége lesz a korábban, a klinikánál megadott telefonszámára, és email címére vagy TAJ számára. Biztos benne, hogy új jelszót hoz létre? Ez később nem visszavonható.",
												() => {
													setForgotPassword(true);
													setActiveCard(0);
												},
												() => {
												},
												props.translates ? props.translates.yes : "Igen",
												props.translates ? props.translates.cancel : "Mégsem",
												props.translates ? props.translates.create_new_password : "Új jelszó létrehozása"
											);
										}}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid container justifyContent={'center'} style={{marginTop: '2rem'}}>
						<Grid item>
							<MainBtn
								disabled={!checkedPw}
								onClick={() => {
									passwordSend();
								}}
							>
								{props.translates ? props.translates.next : "Tovább"}
							</MainBtn>
						</Grid>
					</Grid>
				</div>
			) : null}
		</div>
	);
};

export default LoginPage;
